import { Stack, Typography, Button, Box, Divider } from '@mui/material';
import SiloRealLogo from '../../assets/logos/siloreal-logo-black.webp';
import { useNavigate } from 'react-router';
import { ModalIOF } from '@old/ui/modal/modal';

// LaSegunda
import redSojaIcon from '../../assets/svg/icons-species-red/soja-red.svg';
import redMaizIcon from '../../assets/svg/icons-species-red/maiz-red.svg';
import redTrigoIcon from '../../assets/svg/icons-species-red/trigo-red.svg';
import redCebadaIcon from '../../assets/svg/icons-species-red/cebada-red.svg';
import redGirasolIcon from '../../assets/svg/icons-species-red/girasol-red.svg';
// Galicia
import sojaGaliciaIcon from '../../assets/svg/icons-species-galicia/soja-galicia.svg';
import maizGaliciaIcon from '../../assets/svg/icons-species-galicia/maiz-galicia.svg';
import trigoGaliciaIcon from '../../assets/svg/icons-species-galicia/trigo-galicia.svg';
import cebadaGaliciaIcon from '../../assets/svg/icons-species-galicia/cebada-galicia.svg';
import girasolGaliciaIcon from '../../assets/svg/icons-species-galicia/girasol-galicia.svg';
// Federación Patronal
import sojaFedPat from '../../assets/svg/icons-species-fedpatronal/soja-fedpatronal.svg';
import maizFedPat from '../../assets/svg/icons-species-fedpatronal/maiz-fedpatronal.svg';
import trigoFedPat from '../../assets/svg/icons-species-fedpatronal/trigo-fedpatronal.svg';
import cebadaFedPat from '../../assets/svg/icons-species-fedpatronal/cebada-fedpatronal.svg';
import girasolFedPat from '../../assets/svg/icons-species-fedpatronal/girasol-fedpatronal.svg';

import { PATH } from '@old/data/core/paths';
import { useGlobalStore } from '@old/global-store/use-store';
import { useService } from '@old/hooks/use-service';
import { updateUserDataService } from '@old/services/domain/user/base/user-edition';

type InsuranceIntegrationModalProps = {
  type: 'lasegunda' | 'galicia' | 'fedpatronal';
  open: boolean;
  setOpen: (value: boolean) => void;
};

export function InsuranceIntegrationPopUpModal(props: InsuranceIntegrationModalProps) {
  const { userID, setIshowOneModal } = useGlobalStore();

  const { trigger } = useService(updateUserDataService);
  const navigate = useNavigate();

  const { open, setOpen } = props;

  const ENTITY_MAP = {
    lasegunda: 'La Segunda',
    galicia: 'Galicia Seguros',
    fedpatronal: 'Federación Patronal',
  };
  const LOGO_MAP = {
    lasegunda: 'https://iofbucket.s3.amazonaws.com/logo/logo+la+segunda+rojo.svg',
    galicia: 'https://iofbucket.s3.amazonaws.com/logo/Logo%20Galicia%20Seguros%20Color.svg',
    fedpatronal: 'https://iofbucket.s3.amazonaws.com/logo/Logo%20FedPat%20Color.svg',
  };

  const SPECIES_MAP = {
    lasegunda: {
      soja: redSojaIcon,
      maiz: redMaizIcon,
      trigo: redTrigoIcon,
      cebada: redCebadaIcon,
      girasol: redGirasolIcon,
    },
    galicia: {
      soja: sojaGaliciaIcon,
      maiz: maizGaliciaIcon,
      trigo: trigoGaliciaIcon,
      cebada: cebadaGaliciaIcon,
      girasol: girasolGaliciaIcon,
    },
    fedpatronal: {
      soja: sojaFedPat,
      maiz: maizFedPat,
      trigo: trigoFedPat,
      cebada: cebadaFedPat,
      girasol: girasolFedPat,
    },
  };
  const CALL_TO_ACTION_STYLES_MAP = {
    lasegunda: {
      background: 'linear-gradient(45deg, #E20039 0%, #E20039 67%, #facdd4 100%)',
      color: '#FFFFFF',
      boxShadow: '0px 3px 6px rgba(226, 0, 57, 0.4)',
      '&:hover': {
        background: 'linear-gradient(45deg, #fa144e 0%, #fa144e 67%, #facdd4 100%)',
        boxShadow: '2px 5px 8px rgba(226, 0, 57, 0.6)',
      },
    },
    galicia: {
      background: 'linear-gradient(60deg, #fa6503 0%, #fa6503 75%, #0033A0 100%)',
      boxShadow: '0px 3px 6px rgba(250, 101, 3, 0.4)',
      '&:hover': {
        background: 'linear-gradient(60deg, #FF8A1E 0%, #FF8A1E 75%, #0033A0 100%)',
        boxShadow: '2px 5px 8px rgba(250, 101, 3, 0.6)',
      },
    },
    fedpatronal: {
      background: 'linear-gradient(45deg, #004AAD 0%, #004AAD 67%, #A9C4F5 100%)',
      boxShadow: '0px 3px 6px rgba(0, 74, 173, 0.4)',
      '&:hover': {
        background: 'linear-gradient(45deg, #0066FF 0%, #0066FF 67%, #A9C4F5 100%)',
        boxShadow: '2px 5px 8px rgba(0, 74, 173, 0.6)',
      },
    },
  };

  const insurance = {
    enterprise: ENTITY_MAP[props.type],
    logo: LOGO_MAP[props.type],
    speciesIcon: {
      soja: SPECIES_MAP[props.type].soja,
      maiz: SPECIES_MAP[props.type].maiz,
      trigo: SPECIES_MAP[props.type].trigo,
      cebada: SPECIES_MAP[props.type].cebada,
      girasol: SPECIES_MAP[props.type].girasol,
    },
    callToActionStyles: CALL_TO_ACTION_STYLES_MAP[props.type],
  };

  const updateShownPopupFlag = () => {
    const body = {
      lasegunda: { was_la_segunda_popup_shown: true },
      galicia: { was_galicia_popup_shown: true },
      fedpatronal: { was_federacion_patronal_popup_shown: true },
    };
    trigger({
      query: userID!,
      body: body[props.type],
    });
  };
  const handleClose = () => {
    setOpen(true);
    setIshowOneModal(true);
  };
  const handleCancelInsurance = () => {
    updateShownPopupFlag();
    handleClose();
  };
  const handleGoToQuote = () => {
    updateShownPopupFlag();
    handleClose();
    navigate(PATH.SILOBAG);
  };

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen} width="48%">
      <ModalIOF.HeaderCenter>
        <ModalIOF.Title>
          <Stack direction="row" spacing={2} justifyContent="space-around" alignItems="center">
            <Box>
              <img src={SiloRealLogo} alt="SiloReal Logo" style={{ width: '144px', padding: 10 }} />
            </Box>
            <Divider orientation="vertical" flexItem />

            <img src={insurance.logo} alt={`${insurance.enterprise} Logo`} style={{ width: '175px' }} />
          </Stack>
        </ModalIOF.Title>
      </ModalIOF.HeaderCenter>
      <ModalIOF.Body>
        <Stack direction="column" spacing={2} sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Nueva Alianza con {insurance.enterprise}
          </Typography>
          <Stack direction={'row'} justifyContent={'center'}>
            <Box>
              <img
                src={insurance.speciesIcon.soja}
                alt="Soja"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Soja
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.maiz}
                alt="Maíz"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Maíz
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.trigo}
                alt="Trigo"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Trigo
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.cebada}
                alt="Cebada"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Cebada
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.speciesIcon.girasol}
                alt="Girasol"
                style={{ width: '50px', margin: '15px 25px 10px 25px' }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Girasol
              </Typography>
            </Box>
          </Stack>
        </Stack>
        <Box sx={{ margin: '20px 0px' }}>
          <Typography
            sx={{
              margin: 'auto',
              width: '600px',
              fontSize: '19px',
              textAlign: 'center',
              textWrap: 'balance',
            }}
          >
            Ahora vas a poder contratar tus coberturas de seguros con{' '}
            <span style={{ fontWeight: 600 }}>
              {insurance.enterprise}
              desde SiloReal
            </span>
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} justifyContent={'center'}>
          <Button
            color="error"
            sx={{ border: 'none', color: 'black', textTransform: 'none' }}
            onClick={handleCancelInsurance}
          >
            Quizás más tarde
          </Button>
          <Button
            variant="contained"
            sx={{
              color: '#FFF',
              fontSize: 14,
              borderRadius: 100,
              textTransform: 'none',
              padding: '0px 30px',
              margin: '10px',
              ...insurance.callToActionStyles,
            }}
            onClick={handleGoToQuote}
          >
            Ir a Cotizar
          </Button>
        </Stack>
      </ModalIOF.Body>
    </ModalIOF>
  );
}
